import axios from "axios";
import { env } from "./EnvironmentConfig";

const API = axios.create({
  baseURL: env.API_ENDPOINT_URL,
});

API.interceptors.request.use(
    (req) => {
      const isPanel = window.location.pathname.startsWith('/panel');
      
      const primaryTokenKey = isPanel ? 'panelToken' : 'token';
      let raw = localStorage.getItem(primaryTokenKey);
      
      if (!raw) {
        const fallbackTokenKey = isPanel ? 'token' : 'panelToken';
        raw = localStorage.getItem(fallbackTokenKey);
      }
      
      if (raw) {
        try {
          const parsed = JSON.parse(raw);
          const accessToken = parsed?.data?.accessToken;
          if (accessToken) {
            req.headers.Authorization = `Bearer ${accessToken}`;
          } else {
            localStorage.removeItem(primaryTokenKey);
            localStorage.removeItem('token');
            localStorage.removeItem('panelToken');
          }
        } catch {
          localStorage.removeItem(primaryTokenKey);
        }
      }
      return req;
    },
    (error) => Promise.reject(error)
);

API.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;

      if (status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("panelToken");
        localStorage.removeItem("userType");
        
        const isPanel = window.location.pathname.startsWith('/panel');
        const isThirdParty = window.location.pathname.startsWith('/third-party');
        
        if (isPanel) {
          window.location.href = "/auth/ap-login";
        } else if (isThirdParty) {
          window.location.href = "/auth/login-1";
        } else {
          window.location.href = "/auth/login";
        }
      }

      return Promise.reject(error);
    }
);

export default API;